import axios from "../api/axios";
import useAuth from "./useAuth";
import { disableFakeAuth } from "../config/fakeAuth";

const LOGOUT_URL = "/wp-json/api-bearer-auth/v1/logout";

const useLogout = () => {

	const { setAuth } = useAuth();

	const logout = async () => {
		window.localStorage.removeItem("userProfileData");
		disableFakeAuth(); // Que el toggle de dev no reviva la sesión al recargar
		setAuth({});
		axios(LOGOUT_URL, { withCredentials: true })
			.catch(err => console.error(err));
	};

	return logout;
};

export default useLogout;